import settings from "@assets/web-v3-images/icons/settings.png";

const SettingsIcon = ({ width = 96, height = 96, className }) => (
  <img src={settings} alt="Settings" width={width} height={height} className={className} />
);

export default SettingsIcon;
